import { getPosieRotationRatioByRange } from 'utils/posie-rotation-ratio/posie-rotation-ratio';

export const rankingWarningTooltip: { [key: string]: string } = {
    UNVERIFIED: 'Unverified properties can only show estimated ranking',
    PRIVACY: 'This location is restricted and therefore cannot be analyzed',
    CUSTOM_POI: 'Custom POIs can only show estimated ranking',
    CLOSED: 'Closed or Partially Closed venues can only show estimated ranking',
    PARTIALLY_CLOSED: 'Closed or Partially Closed venues can only show estimated ranking',
    MONTHLY_FLAGGED:
        'This property had irregular visitation during the analyzed period and therefore only shows an estimated ranking',
    OTHER: 'This property can only show an estimated ranking',
    NEW_POI: `Recently created POI - Metrics will become available within ${getPosieRotationRatioByRange(
        { type: 'NEW_POI', range: 'day' },
    )}`,
    NEW_CUSTOM_POI: `Recently created Custom POI - Metrics will become available within ${getPosieRotationRatioByRange(
        { type: 'NEW_CUSTOM_POI', range: 'day' },
    )}`,
    UPDATED_CUSTOM_POI: `Recently edited Custom POI - Metrics will be updated within ${getPosieRotationRatioByRange(
        { type: 'NEW_CUSTOM_POI', range: 'day' },
    )}`,
    MARKET_METRICS: `Recently Added Market - Metrics will become available within ${getPosieRotationRatioByRange(
        { type: 'NEW_MARKET', range: 'day' },
    )}`,
};

export const PRIVACY_RANK_ERROR = 'PRIVACY';
